import React from "react";
import styles from "./ui.module.scss";
import EventOrganizerBlock from "./EventOrganizerBlock";
import EventShareBlock from "./EventShareBlock";
import { useEventStore } from "../../store";
import { TRecipientData } from "../../../../stores/RecipientStore";

const EventOrganizer: React.FC<{ data?: TRecipientData }> = ({
  data = null,
}) => {
  const { eventAuthor } = useEventStore();

  if (!data) if (!eventAuthor) return null;

  return (
    <div className={styles.EventOrganizer}>
      <EventOrganizerBlock data={data?.author} />
      <EventShareBlock data={data} />
    </div>
  );
};

export default EventOrganizer;
